import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedGeneratedDocumentsResidenceApiService } from './generated-documents-residence-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class GeneratedDocumentsResidenceApiService extends GeneratedGeneratedDocumentsResidenceApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
